import { render, staticRenderFns } from "./sideAdd.vue?vue&type=template&id=a1570d8c&scoped=true&lang=html"
import script from "./sideAdd.vue?vue&type=script&lang=js"
export * from "./sideAdd.vue?vue&type=script&lang=js"
import style0 from "./sideAdd.vue?vue&type=style&index=0&id=a1570d8c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_qhqm3mauky62uixplfzayyuc5e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1570d8c",
  null
  
)

export default component.exports